import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import SelectMultiple from '@/components/_custom/Selector/selectMultiple/selectMultiple'
import { Group } from '@/types/Group'
import { SelectOption, SelectOptions } from '@/types/Select'
import { parsePriorityValues, ParsedPriorityValues, PriorityValue } from '../../functions/priorityValues'
import { useDialog } from '@/hooks/useDialog/useDialog'
import Groups from '@/container/daycare/daycareProfile/settings/modals/group/group'

interface SlotPriorityFieldProps {
    groups: Group[]
    childOptions: SelectOptions<PriorityValue>
    groupIds: number[]
    childIds: number[]
    setGroupIds(ids: number[]): void
    setChildIds(ids: number[]): void
}

const SlotPriorityField: FunctionComponent<SlotPriorityFieldProps> = ({
    groups,
    childOptions,
    groupIds,
    childIds,
    setGroupIds,
    setChildIds
}: SlotPriorityFieldProps) => {
    const { t } = useTranslation()

    const { dialog, reopenTrigger, openDialogActionItem } = useDialog({
        dialogTitle: t('myPriorityGroup'),
        Component: Groups,
        resourceLabel: { type: 'manageResource', label: t('myPriorityGroup') }
    })

    const selectOptions: SelectOptions<PriorityValue> = [
        {
            name: t('priorityGroup'),
            options: groups.map(
                (group: Group): SelectOption<PriorityValue> => ({
                    name: group.name.valueOf(),
                    value: { type: 'group', id: group.id }
                })
            )
        },
        ...(childOptions.length === 0 ? [] : childOptions)
    ]

    const values: PriorityValue[] = [
        ...groupIds.map((groupId: number): PriorityValue => ({ type: 'group', id: groupId })),
        ...childIds.map((childId: number): PriorityValue => ({ type: 'child', id: childId }))
    ]

    function handleSelect(selected: PriorityValue[]): void {
        const { groupIds: newGroupIds, childIds: newChildIds }: ParsedPriorityValues = parsePriorityValues(selected)
        setGroupIds(newGroupIds)
        setChildIds(newChildIds)
    }

    return (
        <>
            <SelectMultiple
                selectOptions={selectOptions}
                selectValues={values}
                getValueKey={(value: PriorityValue) => `${value.type}:${value.id}`}
                setSelectValues={handleSelect}
                label={t('priority')}
                actionItem={openDialogActionItem}
                reopenTrigger={reopenTrigger}
            />
            {dialog}
        </>
    )
}

export default SlotPriorityField
